import { Switch, Tooltip } from '@mui/material'

// `BiShapeTriangle` SVG path (react-icons/bi) — triangle outline with a
// small circle at each vertex. Rendered as a CSS mask so the fill
// picks up the thumb's `backgroundColor` (white) and stands out on the
// coloured switch surface.
const TRIANGLE_SVG_URL = `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M18 15c-.183 0-.358.022-.532.054L8.946 6.532C8.978 6.359 9 6.182 9 6c0-1.654-1.346-3-3-3S3 4.346 3 6c0 1.302.839 2.401 2 2.815v6.369A2.997 2.997 0 0 0 3 18c0 1.654 1.346 3 3 3a2.993 2.993 0 0 0 2.815-2h6.369a2.994 2.994 0 0 0 2.815 2c1.654 0 3-1.346 3-3S19.654 15 18 15zm-11 .184V8.816c.329-.118.629-.291.894-.508l7.799 7.799a2.961 2.961 0 0 0-.508.894h-6.37A2.99 2.99 0 0 0 7 15.184zM6 5a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm0 14a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm12 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2z'/></svg>")`

export interface TaTraceToggleProps {
  checked: boolean
  onChange: (v: boolean) => void
  testId?: string
}

// Small on/off switch for the answer trace gutter. The thumb carries a
// baked-in `BiShapeTriangle` glyph (white) so users can see at a glance
// that this switch controls the trace view rather than a generic
// setting.
export default function TaTraceToggle({ checked, onChange, testId }: TaTraceToggleProps) {
  return (
    <Tooltip title={checked ? 'Hide trace' : 'Show trace'} disableInteractive>
      <Switch
        size="small"
        checked={checked}
        onChange={(_e, v) => onChange(v)}
        data-testid={testId}
        sx={{
          '& .MuiSwitch-thumb': {
            position: 'relative',
            backgroundColor: 'text.disabled',
          },
          '& .Mui-checked .MuiSwitch-thumb': {
            backgroundColor: 'primary.main',
          },
          '& .MuiSwitch-thumb::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            margin: 'auto',
            width: '80%',
            height: '80%',
            backgroundColor: '#fff',
            maskImage: TRIANGLE_SVG_URL,
            WebkitMaskImage: TRIANGLE_SVG_URL,
            maskSize: 'contain',
            WebkitMaskSize: 'contain',
            maskRepeat: 'no-repeat',
            WebkitMaskRepeat: 'no-repeat',
            maskPosition: 'center',
            WebkitMaskPosition: 'center',
          },
        }}
      />
    </Tooltip>
  )
}
